import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
    createLeague,
} from './../../actions/LeagueActions';
import {
    teamNameValidation,
} from './../../actions/FormationActions';
import LeagueShare from './league-share';
import NextBtn from './../onboarding/NextBtn'
import config from './../../config';
import common from './../../common';
import apiError from './../../constants/api-error';
import GeneralPopUp from './../GeneralPopUp';
import AdBottom from '../AdBottom';
import OutsideNotifier from '../../OutsideNotifier';
import trackEventsObj from '../../constants/new-pageTrackEvents'

class CreateLeaguePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leagueName: '',
            isDisabled: true,
            message: '',
            inlineMessage: '',
            popupWrapperClass: '',
            iconClass: '',
            leagueCreated: false,
            showPopup: false,
            showShare: false
        };
    }

    componentDidMount() {
        common.pageViewTracking("", trackEventsObj["createLeague"]);
    }

    isDisabled = (value) => {
        return (value.length === 0) ||
            (value.trim().length > config.MAX_LEAGUE_NAME_LENGTH) ||
            (value.trim().length < config.MIN_LEAGUE_NAME_LENGTH);
    };
    handleChange = (event) => {
        const val = common.validateInput(event.target.value);
        this.setState({ leagueName: val, isDisabled: this.isDisabled(val) });
    };
    resetToast = () => {
        this.setState({ showPopup: false, message: '' });
    };
    hitCreateTeam = () => {
        common.showLoader();
        const GUID = common.getGUID();
        this.props.createLeague(GUID, this.state.leagueName).then(() => {
            common.hideLoader();
            const response = this.props.createLeagueResponse;
            const retVal = response.Meta['RetVal'];
            const errorKeyFromTrans = apiError.createLeague[retVal];
            const message = this.props.trans[errorKeyFromTrans];
            if (response.Meta['Success'] && retVal === 1) {
                common.customTracking('League Created', '/uclfantasy/leagues/');
                sessionStorage.setItem('leagueCreated', true);
                return this.props.history.push('/league-leaderboard/' + response.Data.Value.LeagueId);
            } else {
                let stateToSet = {
                    message,
                    isToast: true,
                    popupWrapperClass: 'si-warning-toast si-error-popup',
                    iconClass: 'icon-ucl-warning-icon',
                    showPopup: true
                };
                if (retVal === 4) {
                    stateToSet = {
                        inlineMessage: message,
                    };
                }
                this.setState(stateToSet);
            }
        });
    };

    checkForProfanity = () => {
        common.showLoader();
        let self = this;
        this.props.callTeamNameValidation(this.state.leagueName.trim()).then(() => {

            const teamNameValidationResponse = self.props.teamNameValidation.response;
            const retVal = teamNameValidationResponse.Meta['RetVal'];
            if (teamNameValidationResponse.Meta['Success'] && retVal === 1) {
                common.hideLoader();
                // return this.props.history.push('/favourite-club');
                setTimeout(() => {
                    self.hitCreateTeam()
                }, 100)

            } else {
                common.hideLoader();
                const message = apiError.updateTeamName[retVal];
                self.setState({
                    inlineMessage: self.props.trans[message]
                });
            }

        });
    }
    onBackClick = () => {
        return this.props.history.goBack();
    };
    goToSettings = (leagueID) => {
        return this.props.history.push('/league-settings/' + leagueID);
    };
    onShareTap = () => {
        this.setState((previousState) => {
            return { showShare: !previousState.showShare };
        });
    };

    onClosePopup() {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    render() {
        const { trans } = this.props;
        const {
            leagueName, isDisabled, message, inlineMessage,
            showPopup, popupWrapperClass, iconClass, showShare, isToast
        } = this.state;
        let dataToShare = {};
        const wrapperClass = common.makeClasses({
            'si-main-component': true,
            'si-manage-team': true,
            'si-no-anim': true,
            'si-leagues': true,
        });
        const nextBtnProps = {
            isDisabled: isDisabled,
            showTitle: isDisabled,
            tooltipText: trans['create_league_btn'],
            text: trans['create_league_btn'],
            handler: () => this.checkForProfanity(),
        };
        const popupProps = {
            showPopup,
            resetToast: this.resetToast,
            message,
            isToast,
            wrapperClass: popupWrapperClass,
            iconClass: iconClass
        };
        const LeagueNameWithError = common.makeClasses({
            'si-league-name': true,
            'si-error': inlineMessage
        });
        return (
            <div className="si-modal-wrap">
                <OutsideNotifier handler={ () => { this.onClosePopup() } }>
                    <div className="si-common-popup si-lg-create">
                        <i className="si-close icon-ucl-close" onClick={ () => { this.onClosePopup() } }></i>
                        <div className="si-popup-body si-flexBox">
                            <div className={ LeagueNameWithError }>
                                <div className="si-league-nm-head">{ trans['create_a_league'] || "Create a league" }</div>
                                <div className="si-title">{ trans['league_name_title'] || "League Name" }</div>
                                <div className="si-input-wrap">
                                    <label>{ config.MAX_LEAGUE_NAME_LENGTH - this.state.leagueName.length }</label>
                                    <input type="text" name="leagueName"
                                        maxLength={ config.MAX_LEAGUE_NAME_LENGTH }
                                        value={ leagueName }
                                        onChange={ (e) => this.handleChange(e) }
                                        placeholder={ trans['enter_league_name_placeholder'] } />
                                </div>
                                {
                                    inlineMessage
                                        ?
                                        <div className="si-error-msg">
                                            <span>{ inlineMessage }</span>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                        </div>
                        <div className="si-popup-btn-wrap">
                            <div
                                className={ "si-btn si-btn-primary " + (isDisabled ? "si-btn-disabled" : "") }
                                title={ isDisabled ? trans['create_league_btn'] : "" }
                                onClick={ () => { this.checkForProfanity() } }
                            >
                                <span>{ trans['create_league_btn'] }</span>
                            </div>
                        </div>
                    </div>
                </OutsideNotifier>
            </div>
        )
        // return <div className={wrapperClass}>
        {/* <div className="si-container">
                <div className="si-top-section">
                    <div className="si-leagues-header si-flexBox">
                        <div className="si-back-btn si-cols">
                            <i className="icon-ucl-back_arrow" onClick={() => this.onBackClick()} />
                        </div>
                        <div className="si-cols si-header-txt">
                            <span>
                                {trans['new_league']}</span>
                        </div>
                        <div className="si-common-menu">
                        </div>
                    </div>
                </div>
                <div className="si-leagues-container">
                    <div className={LeagueNameWithError}>
                        <div className="si-title">{trans['league_name']}</div>
                        <div className="si-input-wrap">
                            <label>{config.MAX_LEAGUE_NAME_LENGTH - this.state.leagueName.length}</label>
                            <input type="text" name="leagueName"
                                maxLength={config.MAX_LEAGUE_NAME_LENGTH}
                                value={leagueName}
                                onChange={(e) => this.handleChange(e)}
                                placeholder={trans['enter_league_name_placeholder']} />
                        </div>
                        {inlineMessage ? <div className="si-error-msg">
                            <span>{inlineMessage}</span>
                        </div> : null}
                        <div className="si-btn-wrp">
                            <NextBtn {...nextBtnProps} />
                        </div>
                    </div>
                </div>
                <AdBottom />
            </div> */}
        // <GeneralPopUp {...popupProps} />
        // {showShare ? <LeagueShare {...dataToShare} trans={trans} toHide={this.onShareTap.bind(this)} /> : null}
        // </div>
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createLeague: (GUID, leagueName) => dispatch(createLeague(GUID, leagueName)),
        callTeamNameValidation: (teamName) => dispatch(teamNameValidation(teamName)),
    };
};
const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        createLeagueResponse: state.leaguesData.createLeagueResponse,
        teamNameValidation: state.formationData.teamNameValidation,
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CreateLeaguePopup));


// WEBPACK FOOTER //
// ./src/components/leagues/create-league-popup.js